import React from 'react'
import bg from '../../Images/shapes/7.png'
import person from '../../Images/female/Person Image.png'

const About = () => {
  return (
    <section className='h-screen px-20' style={{backgroundImage: `url(${bg})`}}>
        
        <main className='lg:flex justify-around items-center'>
            {/* image section */}
            <div className='flex-1'>
                <img className='w-[338px] pt-10' src={person} alt="" />
            </div>

            {/* tittle section */}
            <div className='flex-1 pt-10'>
                <h1 className='text-[#707070] font-bold text-4xl'>
                About Me
                </h1> <br />

                <p className='text-[#18191F] font-normal text-lg'>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Condimentum diam orci pretium a pharetra, feugiat cursus. Dictumst risus, sem egestas odio cras adipiscing vulputate. Nisi, risus in suscipit non. Non commodo volutpat, pharetra, vel.
                </p> <br /><br />

                <button className='bg-gradient-to-r from-orange-400 to-red-500 py-2 px-4 rounded-full text-white text-medium'>Contact me</button>
            </div>
        </main>
    </section>
  )
}

export default About